import { jsxs as t, jsx as i } from "react/jsx-runtime";
import '../../assets/index.css';const o = "_transformationCard_1hb4m_1", m = "_imageContainer_1hb4m_15", c = "_image_1hb4m_15", _ = "_overlay_1hb4m_27", d = "_initialTitle_1hb4m_41", h = "_hoverDetails_1hb4m_48", v = "_detailsTitle_1hb4m_70", g = "_detailsDescription_1hb4m_77", a = {
  transformationCard: o,
  imageContainer: m,
  image: c,
  overlay: _,
  initialTitle: d,
  hoverDetails: h,
  detailsTitle: v,
  detailsDescription: g
};
function T({
  imageUrl: n,
  title: e,
  description: s,
  className: l,
  textCardBackgroundColor: r
}) {
  return console.log({ textCardBackgroundColor: r }), /* @__PURE__ */ t("div", { className: `${a.transformationCard} ${l || ""}`, children: [
    /* @__PURE__ */ i("div", { className: a.imageContainer, children: /* @__PURE__ */ i("img", { src: n, alt: e, className: a.image }) }),
    e && /* @__PURE__ */ i("div", { className: a.overlay, children: /* @__PURE__ */ i("p", { className: a.initialTitle, children: e }) }),
    e && s && /* @__PURE__ */ t("div", { className: a.hoverDetails, children: [
      /* @__PURE__ */ i("h3", { className: a.detailsTitle, children: e }),
      /* @__PURE__ */ i("p", { className: a.detailsDescription, children: s })
    ] })
  ] });
}
export {
  T as TransformationImageCard
};
